import { createSelector } from '@reduxjs/toolkit';
import { overdueEventOccurrences } from './overdue-event-occurrences';
import { unscheduledEventOccurrences } from './unscheduled-event-occurrences';
import { getOrganization } from '../organization/getOrganization';
import { employeesAndContactsOptions } from '../organization/employeesAndContactsOptions';
import { currentUserUuid } from '../user/currentUserUuid';
import { getContactsAsUsers } from '../partners/get-contacts-as-users';
import { employeesShortNamesAndI } from '../employees/employees-short-names-and-i';
import { singleUserVersion } from '../organization/singleUserVersion';
import { functionsNotDeleted } from '../responsibilities/functions-not-deleted';
import { homePageEventItem } from './home-page-event-item';

export const todoList = createSelector(
  overdueEventOccurrences,
  unscheduledEventOccurrences,
  getOrganization,
  employeesAndContactsOptions,
  currentUserUuid,
  getContactsAsUsers,
  employeesShortNamesAndI,
  singleUserVersion,
  functionsNotDeleted,
  (
    overdueEventOccurrences,
    unscheduledEventOccurrences,
    organization,
    employeesAndContacts,
    currentUserUuid,
    contactsAsUsers,
    employeesShortNamesAndI,
    singleUserVersion,
    functions,
  ) => {
    if (organization === undefined) return [];
    return [
      ...overdueEventOccurrences.map((x) =>
        homePageEventItem(
          x,
          true,
          organization,
          employeesAndContacts,
          currentUserUuid ?? '',
          contactsAsUsers,
          employeesShortNamesAndI,
          singleUserVersion,
          functions,
        ),
      ),
      ...unscheduledEventOccurrences.map((x) =>
        homePageEventItem(
          x,
          false,
          organization,
          employeesAndContacts,
          currentUserUuid ?? '',
          contactsAsUsers,
          employeesShortNamesAndI,
          singleUserVersion,
          functions,
        ),
      ),
    ];
  },
);
